var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"align":"center"}},[_c('br'),_c('br'),_c('pulse-loader',{attrs:{"color":"#4471b0","size":"10px"}}),_c('br'),_c('h6',[_vm._v("Fetching your data, please wait..")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }